// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1DYfK","upload":"Small_upload__3j92v","imageWrap":"Small_imageWrap__ItDa9","removeBtn":"Small_removeBtn__LWgva"};